import { Box } from "@chakra-ui/react";
import React, { Fragment } from "react";
import { splitTextForSearchHighlighting } from "./utils/textUtils";

export type HighlightedSearchTextProps = {
  text?: string;
  query: string;
  highlightSnippet?: string;
};

/** Renders `text` with Typesense search hits emphasized (yellow mark). */
export function HighlightedSearchText({
  text,
  query,
  highlightSnippet,
}: HighlightedSearchTextProps) {
  const segments = splitTextForSearchHighlighting(text ?? "", query, highlightSnippet);
  return (
    <>
      {segments.map((s, i) =>
        s.highlight ? (
          <Box
            as="mark"
            key={i}
            bg="yellow.200"
            display="inline"
            px={0}
            lineHeight="inherit"
          >
            {s.text}
          </Box>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        ),
      )}
    </>
  );
}
